// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trial-image[data-v-55c33548]{border-radius:8px;overflow:hidden}.trial-footer[data-v-55c33548]{bottom:0;box-shadow:0 0 0 1px rgba(14,16,20,.04),0 0 2px rgba(14,16,20,.08),0 4px 12px rgba(14,16,20,.08);position:sticky}.trial-title[data-v-55c33548]{font-size:19px;line-height:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
